import styled from '@emotion/styled'
import { themeColor } from 'utils/styles'
import SelectMenu from 'components/patterns/Inputs/SelectMenu'
import { CollapsibleWidget, Paragraph, Pill } from 'components/patterns'

export const StyledSelectMenu = styled(SelectMenu)`
  .ant-select {
    width: 100%;
  }
`
export const SwitchPartListHeader = styled(Paragraph)`
  font-size: 12px;
  color: ${themeColor('bluePrimary')};
`

export const Switch = styled.div``

export const PartDescription = styled(Paragraph)`
  font-weight bold;
  font-size: 12px;
`

export const PartInfoList = styled.div`
  display: flex;
  flex-direction: row;
`

export const PartInfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: end;
  margin-right: 5px;
`

export const PartVehicleModel = styled(Paragraph)`
  font-size: 12px;
  margin-right: 4px;
`

export const PartNumber = styled(Paragraph)`
  font-size: 12px;
  margin-right: 5px;
`

export const OptionRow = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 8px;
  overflow: hidden;
`

export const OptionLabel = styled.span`
  flex-shrink: 0;
`

export const SwitchCustomNamePill = styled(Pill)`
  display: flex;
  align-items: center;
  margin-left: 0;
  margin-right: 0;
  width: auto;
  flex: 0 1 auto;
  min-width: 0;
  height: 15px;
  border-radius: 8px;
  padding: 0 8px;
  font-size: 10px;
  font-weight: bold;
  text-transform: uppercase;
  overflow: hidden;
  background-color: ${themeColor('blueAccent')};
`

export const PillText = styled.span`
  display: block;
  flex: 1;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  position: relative;
  top: 1px;
`

export const CollapsibleSwitchList = styled(CollapsibleWidget)`
  margin-bottom: 20px;
  &&.ant-collapse > .ant-collapse-item {
    border-bottom: 0px;
  }
  &&.ant-collapse > .ant-collapse-item > .ant-collapse-header {
    right: 29px;
  }
  &&.ant-collapse
    > .ant-collapse-item
    > .ant-collapse-header
    .ant-collapse-arrow {
    left: 170px;
  }
  &&.ant-collapse-borderless
    > .ant-collapse-item
    > .ant-collapse-content
    > .ant-collapse-content-box {
    padding: 0px;
  }
`
